<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import B2BSlider from "@js/components/Sections/B2B/B2BSlider.vue";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import {Link} from "@inertiajs/vue3";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "AboutCompanyPage",
    components: {
        Link,
        RequisiteTable,
        B2BSlider,
        Breadcrumbs,
        MobileTopBar,
    },
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-bold mb-5">
            О компании
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <div class="grid grid-cols-1 gap-5">
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <p class="mb-4">
                        <span class="font-bold">ООО «МОДА КЕРАМИКС РУС»</span> была основана профессионалами
                        строительной и интерьерной сфер в 2024 году с
                        целью стать надёжным партнёром для архитекторов, дизайнеров и строителей по всей России.
                        Опираясь на многолетний опыт и тесное сотрудничество с ведущими производителями плитки, мы
                        гарантируем высокое качество продукции и комплексный подход к каждому проекту. Мы являемся
                        частью <span class="font-bold">группы компаний DCL</span>, что позволяет нам обеспечивать
                        надежную логистику, оптимизировать
                        складские процессы и предоставлять интегрированные решения для бизнеса.
                    </p>
                    <p class="mb-4">
                        Наша миссия — вдохновлять заказчиков инновационными решениями в отделке пространств. Мы
                        постоянно расширяем ассортимент, входим в стратегические партнёрства с международными брендами и
                        внедряем передовые технологии для оптимизации логистики и хранения.
                    </p>
                    <p class="mb-4">
                        Команда «МОДА КЕРАМИКС РУС» включает сертифицированных технологов, менеджеров по продукту и
                        специалистов по обслуживанию клиентов. Мы предоставляем консультации на всех этапах: от
                        разработки концепции до финального монтажа плитки, обеспечивая техническую поддержку и
                        рекомендации по уходу.
                    </p>
                    <button @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full mt-4 flex justify-center items-center text-center text-black border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                        Заявка на обратный звонок
                    </button>
                </div>
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Ассортимент</h2>
                    <ul class="list-disc list-inside space-y-2">
                        <li><strong>Керамическая и керамогранитная плитка</strong>: от базовых коллекций до премиальных
                            моделей с уникальным декором.
                        </li>
                        <li><strong>Мозаика и клинкер</strong>: эксклюзивные решения для акцентов в интерьере и
                            экстерьере.
                        </li>
                        <li><strong>Плитка для пола и стен</strong>: устойчивые к нагрузкам и износу покрытия для кухни,
                            ванной, гостиной и общественных пространств.
                        </li>
                        <li><strong>Специальные серии</strong>: антискользящая, противогрибковая и теплоактивная плитка
                            для бассейнов, саун и фитнес-центров.
                        </li>
                    </ul>
                </div>

            </div>
            <div class="grid grid-cols-1 gap-5">
                <div class="grid grid-cols-1 gap-5">
                    <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                        <h2 class="text-xl font-semibold mb-4">Логистика и сервис</h2>
                        <p class="mb-4">
                            Быстрая доставка по всей России и удобные варианты самовывоза из региональных складов.
                            Прозрачное отслеживание статуса заказа, возможность расчёта объёмов и подробные инструкции
                            по укладке. Наши менеджеры готовы проконсультировать по подбору плитки, расходным материалам
                            и техническим характеристикам.
                        </p>
                        <Link :href="route('deliveryAndShipping')"
                              class="mt-4 flex justify-center items-center text-center text-black border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Подробнее о доставке
                        </Link>
                    </div>
                    <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                        <h2 class="text-xl font-semibold mb-4">Почему выбирают нас</h2>
                        <ul class="list-disc list-inside space-y-2 mb-4">
                            <li><strong>Лучшие цены</strong>: прямые поставки от производителей без наценок посредников.
                            </li>
                            <li><strong>Гарантия качества</strong>: сертификаты и строгий контроль соответствия мировым
                                стандартам.
                            </li>
                            <li><strong>Широкий выбор</strong>: тысячи плиток для любого бюджета и стиля — от
                                минимализма до лофта и хай-тека.
                            </li>
                            <li><strong>Профессиональные решения</strong>: подбор материалов под дизайн-проект, помощь
                                технологов и дизайнеров.
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-5">Ваш идеальный проект начинается здесь</h2>
                    <p class="mb-5">
                        Откройте для себя все возможности отделки с «МОДА КЕРАМИКС РУС»: качественная плитка,
                        современные коллекции и полный комплекс услуг для быстрого и надёжного ремонта.
                    </p>
                    <Link :href="route('catalog', {category_title: 'plitka'})"
                          class="mt-4 flex justify-center items-center text-black border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                        Перейти в каталог
                    </Link>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div class="border-2 border-baseColor rounded-3xl overflow-hidden">
                <RequisiteTable/>
            </div>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <h2 class="text-2xl font-semibold mb-6">
                Услуги компании для бизнеса
            </h2>
            <B2BSlider/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
